import React from 'react'
import { Outlet } from 'react-router-dom'

function Cfaelayout() {
  return (
    <div><Outlet/></div>
  )
}

export default Cfaelayout